var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 410.07 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d6d8e5;opacity:0.4;}.cls-2{fill:#b1b4c4;}.cls-3{fill:#616e84;}.cls-4{fill:#20232d;}.cls-5,.cls-7{fill:#fff;}.cls-6{fill:#2b303f;}.cls-7{opacity:0.1;}.cls-8{fill:#757b89;}.cls-9{fill:#e9eaf2;}.cls-10{fill:#d9dae2;}.cls-11{fill:#38226d;}.cls-12{fill:#9c73ff;}.cls-13{fill:#8c50ff;}.cls-14{fill:#ffcea9;}.cls-15{fill:#f4f4f4;}.cls-16{fill:#3a2c6d;}.cls-17{fill:#ededed;}.cls-18{fill:#2b2a30;}.cls-19{fill:#bf4b4b;}.cls-20{fill:#e26161;}.cls-21{opacity:0.5;fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15);}.cls-22{fill:#ff7b7b;}.cls-23{fill:#e26d6d;}.cls-24{opacity:0.2;}.cls-25{fill:#dd990e;}.cls-26{fill:#f9cb07;}.cls-27{fill:#cc8b09;}.cls-28{fill:#4399ff;}.cls-29{fill:#70b6fc;}.cls-30{fill:#efbd9c;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15",
    x1: -2093.15,
    y1: 3284.72,
    x2: -2093.15,
    y2: 3269.47,
    gradientTransform: "matrix(0.87, 0.5, -1, 0.58, 5177.07, -498.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chat_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.87,412.19l-87.81-50.56a3.25,3.25,0,0,1,.13-5.69l11.05-5.69a3.25,3.25,0,0,1,3.1.07l90.76,52.26a3.24,3.24,0,0,1-.13,5.69l-8,4.13A9.48,9.48,0,0,1,245.87,412.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.25,402.67l-74.82-43.2C170.09,355.81,165,346,165,337.55V128.83c0-8.45,5.14-12.33,11.48-8.67l74.82,43.2c6.34,3.66,11.48,13.47,11.48,21.92V394C262.73,402.45,257.59,406.33,251.25,402.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "252.54 406.44 258.47 403.44 252.78 393.69 252.54 406.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "163.79 122.24 169.25 119.38 168.15 127.42 163.79 122.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M246.48,405.06l-74.82-43.2c-6.34-3.66-11.48-13.48-11.48-21.93V131.22c0-8.45,5.14-12.34,11.48-8.68l74.82,43.2c6.34,3.66,11.48,13.48,11.48,21.93V396.38C258,404.83,252.82,408.72,246.48,405.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.16,188.2V396.91c0,8.46-5.13,12.34-11.47,8.68l-29.35-16.94-9.12-5.27-36.36-21c-6.34-3.66-11.47-13.47-11.47-21.93V131.75c0-8.46,5.13-12.33,11.47-8.68l74.83,43.2C252,169.93,257.16,179.74,257.16,188.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M251.77,186.08V389.36c0,5.12-3.59,7.2-8,4.63l-23.39-13.5-2.07-1.19-.69-.41L212.54,376l-14.64-8.43h0l-6.07-3.5-2.44-1.41-16.58-9.57c-4.43-2.56-8-8.79-8-13.92V135.86c0-5.12,3.59-7.2,8-4.64L202,148.09v.08A13.83,13.83,0,0,0,208.27,159c3.46,2,6.26.37,6.26-3.61,0,0,0-.06,0-.09l29.22,16.87C248.18,174.73,251.77,181,251.77,186.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 208.28,
    cy: 153.99,
    rx: 1.94,
    ry: 3.35,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -49.09, 124.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M208.28,155.14a2.21,2.21,0,0,1-1-1.72c0-.64.45-.89,1-.58a2.2,2.2,0,0,1,1,1.73C209.27,155.2,208.83,155.46,208.28,155.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M260.2,215.66h0c-.61.36-1.11,0-1.11-.83v-8.9a2.64,2.64,0,0,1,1.11-2.11h0c.61-.36,1.1,0,1.1.83v8.9A2.63,2.63,0,0,1,260.2,215.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M260.2,230.24h0c-.61.36-1.11,0-1.11-.83v-8.9a2.64,2.64,0,0,1,1.11-2.11h0c.61-.36,1.1,0,1.1.83v8.9A2.63,2.63,0,0,1,260.2,230.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M237.67,207.53,176.9,172.44a7.38,7.38,0,0,1-3.09-5.9V149.8c0-2.27,1.38-3.32,3.09-2.33l60.77,35.08a7.43,7.43,0,0,1,3.09,5.91v16.73C240.76,207.47,239.37,208.51,237.67,207.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "173.81 164.71 173.81 180.17 182.39 175.61 173.81 164.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "232 190.58 186.17 164.12 186.17 159.36 232 185.82 232 190.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "208.83 184.34 186.17 171.25 186.17 166.5 208.83 179.58 208.83 184.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M221.19,283.34,176.9,257.77a7.38,7.38,0,0,1-3.09-5.9v-8.71c0-2.27,1.38-3.32,3.09-2.33l44.29,25.57a7.41,7.41,0,0,1,3.09,5.9V281C224.28,283.28,222.89,284.33,221.19,283.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "173.81 249.75 173.81 265.21 182.39 260.65 173.81 249.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "217.68 275.67 183.13 255.72 183.13 250.96 217.68 270.91 217.68 275.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M198.4,231.43l39.27,22.67c1.7,1,3.09-.06,3.09-2.33V235a7.4,7.4,0,0,0-3.09-5.9L198.4,206.45c-1.71-1-3.09.07-3.09,2.34v16.74A7.4,7.4,0,0,0,198.4,231.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "240.76 249.94 240.76 265.4 232.17 250.93 240.76 249.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "203.42 220.65 229.36 235.63 229.36 230.87 203.42 215.9 203.42 220.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "203.42 227.79 217.32 235.82 217.32 231.06 203.42 223.03 203.42 227.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M176.9,307.62l60.41,34.88c1.71,1,3.09-.06,3.09-2.34V323.43a7.4,7.4,0,0,0-3.09-5.91L176.9,282.64c-1.71-1-3.09.06-3.09,2.34v16.74A7.4,7.4,0,0,0,176.9,307.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "240.4 338.34 240.4 353.8 231.82 339.33 240.4 338.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "183.08 297.51 225.82 322.19 225.82 317.43 183.08 292.75 183.08 297.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "183.08 304.65 222.9 327.64 222.9 322.88 183.08 299.89 183.08 304.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M237.67,379,176.9,343.9a8,8,0,0,1-3.61-6.25v-8.32c0-2.3,1.62-3.23,3.61-2.08l60.77,35.08a8,8,0,0,1,3.6,6.25v8.32C241.27,379.2,239.65,380.13,237.67,379ZM176.9,328.44c-1.42-.82-2.58-.16-2.58,1.48v8.33a5.7,5.7,0,0,0,2.58,4.46l60.77,35.08c1.42.82,2.57.16,2.57-1.48V368a5.69,5.69,0,0,0-2.57-4.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "179.3 341.12 178.27 340.53 178.27 332.6 179.3 333.19 179.3 341.12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Men_8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 361.95,
    cy: 291.11,
    rx: 34.64,
    ry: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M381,286c-2.41,2-6,.17-6.14.35a106.6,106.6,0,0,1-8.89,7.4c-1.5,1.18-3.84,2.76-3.42,5,.76,4.06,7.26,2.81,9.71,1.57s4.45-3.3,6.77-4.74c1.66-1,3.29-1.56,3.55-3.65C382.75,290.69,381.45,285.94,381,286Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M382.56,291.11c-.31,2-1.92,2.55-3.56,3.57-2.36,1.46-4.44,3.58-6.89,4.82-2.26,1.14-7.91,2.28-9.5-.62.86,3.92,7.24,2.69,9.67,1.46s4.45-3.3,6.77-4.74c1.66-1,3.29-1.56,3.55-3.65A4.36,4.36,0,0,0,382.56,291.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M360.12,278.22c-2.41,2-6.63-.18-6.8,0a94.73,94.73,0,0,1-7.95,7.17c-1.5,1.18-3.84,2.76-3.41,5,.75,4.06,7.25,2.81,9.7,1.57s4.46-3.3,6.78-4.74c1.65-1,3.28-1.56,3.54-3.65C362.13,282.33,360.55,278.17,360.12,278.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M361.9,283c-.31,2-1.92,2.55-3.56,3.57-2.36,1.47-4.44,3.58-6.89,4.82-2.26,1.15-7.91,2.29-9.5-.61.86,3.91,7.25,2.68,9.67,1.45s4.45-3.29,6.78-4.74c1.65-1,3.28-1.56,3.54-3.65A4.39,4.39,0,0,0,361.9,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-13",
    d: "M381.1,197c-.11,3.65-1.25,19.47-1.75,27.84s-.63,18.64-.63,18.64,1.45,6.1,2.38,13.27,0,29.8,0,29.8a5.69,5.69,0,0,1-6.17,0s-3.85-18.11-5.64-26.27-2.09-12.86-3-17.92c-1.12-6.12-3.54-34.68-3.54-34.68l-1,.06L359.19,240a36.25,36.25,0,0,1,1.63,7.32c.7,5.25-.74,31.67-.74,31.67a6.4,6.4,0,0,1-6.67-.28s-6.44-35-6.44-40.31c0-3.52.6-50,.6-50Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-14",
    d: "M372.37,126.63s-.41,7.94-.23,8.65,3.64,3,4.65,3.86-5.49,7.25-8.65,8.7-13.18-2.37-13.35-7.29,1.71-9.05,3.25-9.27S372.37,126.63,372.37,126.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M353.21,133.72s-2.15-3.29-10,15S330.52,171.81,327,176.36c-3.18,4.14-4.75-2.44-4.75-2.44s2.53-3.19.42-3.19c-1.18.07-2.83,2.5-2.83,2.5l2.69,4.3,7,3.55s8.57-7.88,11.34-12.74c3-3.83,7.49-11.43,7.49-11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M319.87,176.94c-.08-.06-2.17-2.49-2.17-2.49s-1.25-1.09.11-1.17,6.21-.09,6.21-.09a2,2,0,0,1,1.39.39c.61.48,7.64,9.38,7.64,9.38s.31.54-.6.6-6.8,0-6.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M319.3,175.44s-2.07-.39-1.59,1.6,3.45,4.05,3.45,4.05l3.1,2.6a2.35,2.35,0,0,0,2.54,0c.8-.5,1.92-1.86.69-3.15s-2.33-4.12-5.47-4c0,0-.17-.75-2-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_3",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-15",
    d: "M373.26,136.65s-5.77,8.58-13.81,9.39c-2.53-2.5-2.76-11.39.75-14.23,0,0-3.23-2.61-5.44-2.1a12.06,12.06,0,0,0-5.62,6.54c-1.48,4.53-2.31,9.75-2.18,18.18s0,34.17,0,34.17,1.14,5.45,8.41,9.5S368,202.54,373,201.39c4.07-.95,7.43-2.38,8.83-5.33-.36-5.91-3-21.32-2-28.75s2.55-13,3-19-.8-5.89-3.81-8A46.72,46.72,0,0,0,373.26,136.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_4",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-14",
    d: "M376.48,200.49c1.2-1.34,3.26-8.77,4.44-13.46A47.23,47.23,0,0,0,381.6,171c-1.06-6.4-4-15.26-4.83-18.93s.27-5.23,1.9-6.71c1.91-1.74,4.76-1.22,6.6,3.88A101,101,0,0,1,390.08,171a50.27,50.27,0,0,1-1.43,16.43c-1.23,5-3,8.62-5.34,13.2-.63,1.24-2.07,4.73-3,7.25S375.39,201.71,376.48,200.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-14",
    d: "M354.39,114.79h0c.95-6.17,5.39-10.84,11.75-10.49a12.23,12.23,0,0,1,6.23,22.33,12.46,12.46,0,0,1-1,2.69c-2.25,2.63-9.05,4.26-11,4-2.51-.36-3.86-1.41-5.06-4.15C353.21,124.31,353.87,117.84,354.39,114.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M372.37,126.63h0l-.58-5.38s4.39-11.38-6-9.2c-6.86,1.45-8.58,2.07-10.66-2.53s5.27-8.73,14-7.58A12.07,12.07,0,0,1,380,114.18C379.72,117.57,378.82,124.42,372.37,126.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M390.14,157.5s-5.66,5.64-12.37,4c-1-.65-3.26-13.83-3.26-13.83s0-7.3,5.6-7.11S390.14,157.5,390.14,157.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M347,150.1s-3.67.46-4.89-1.26c.22-3,5.11-18.3,12.7-19.13a25.8,25.8,0,0,0-4.74,5.73C347.36,139.93,347,150.1,347,150.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Men_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 34.58,
    cy: 480.04,
    rx: 34.58,
    ry: 19.96
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_6",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-14",
    d: "M9.22,330.53c-.39,3.36-4.39,17.85-3.53,22.82s14.55,13.27,14.55,13.27l1.9-8.5-7.59-7.43,2.05-14.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_7",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-17",
    d: "M19.81,316.24a6,6,0,0,0-7.62,2.31c-2,3.34-4.11,14.78-4.3,16.74,0,0,2.83,3.9,7.07,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M35.45,477.85a11.74,11.74,0,0,0,8.86-1.07c2.14.07,13.73-4.89,15.3-.73,1.38,3.65-3.64,7-6.32,7.68-5.85,1.41-10.18,4.33-12.53,4.83-1.75.37-4,.61-5.42-.77C33.67,486.14,33.81,480,35.45,477.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M40.76,487.55c2.35-.5,6.68-3.42,12.53-4.83,2.25-.55,6.12-3,6.51-5.94.52,3.36-4,6.34-6.51,7-5.85,1.41-10.18,4.33-12.53,4.83-1.75.37-4,.61-5.42-.77a3.34,3.34,0,0,1-.76-1.39A7,7,0,0,0,40.76,487.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M16.66,469.41a11.74,11.74,0,0,0,8.86-1.07c2.13.07,13.72-4.89,15.3-.73,1.38,3.65-3.64,7-6.32,7.68-5.85,1.42-10.19,4.33-12.54,4.83-1.75.37-4,.61-5.41-.77C14.87,477.7,15,471.59,16.66,469.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M22,479.11c2.35-.5,6.69-3.42,12.54-4.83,2.24-.55,6.12-3,6.51-5.94.52,3.36-4,6.34-6.51,7-5.85,1.42-10.19,4.33-12.54,4.83-1.75.37-4,.61-5.41-.77a3.47,3.47,0,0,1-.77-1.39A7,7,0,0,0,22,479.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-20",
    d: "M16.43,437.93a70,70,0,0,1,2.67-12.69s-.79-10.95-1.19-21.34c-.46-11.78-4.55-22.15-1.32-31.56L53,380.43s-2.2,47-2.69,52.67a105.84,105.84,0,0,1-1.63,13.19c-1.66,9.12-4.36,30.81-4.36,30.81-3.84,2.24-8.89,1-8.89,1s.28-27.44.53-34c.3-8,.54-7.41.54-7.41l-1.2-20-.78-9.94s-1,7.3-1.66,13.82c-.58,5.68-2,10.82-3.48,21.4-1.33,9.18-3.49,27.62-3.49,27.62-3.84,2.23-9.06.38-9.06.38S15.39,445.89,16.43,437.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_9",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-14",
    d: "M21.74,316.44c2.77.14,4.83.85,5.17,0a36.35,36.35,0,0,0,.64-4.33c-.32-.81-.6-1.67-.6-1.67-3.47-2.14-4.57-5.9-5-10.27-.78-7.48,3.26-14,10.74-14.81,7-.74,12.21,4.21,13.59,11,.74,3.35,2.22,9.68.22,15.19-1.12,3.08-2.56,5.53-4,6a36.65,36.65,0,0,1-4.16-.37h0s-.37,2.07-.63,3.41-.15,2,2.5,3.67-4,5-8.37,4.67-9.26-3-10.61-5.78C19.71,320.05,19.84,316.35,21.74,316.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_10",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-15",
    d: "M25.74,316.85c-.76,1.92,1.19,4.26,6.39,5.89s5.67-.47,5.67-.47,7.62,3.48,10.1,5.21c3.13,2.18,4.51,8.5,4.93,19.16.49,12.33.53,30.63.12,33.79,0,0-5.83,5.81-13.3,5.2s-20-7.22-23.07-12.32c.08-10.82,1.35-12.58-.4-18.81-4-14.26-6.12-20.1-4.18-29.58,1.61-7.81,3.86-8.78,7-8.71A65.29,65.29,0,0,1,25.74,316.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-14",
    d: "M64.56,356.84c-6.12,1.54-7.56-2.32-8.37-5.52-1.94-7.75-3-14.74-4.45-19.14-1.71-5.18-3.5-6-6-7-3-1.18-5.5,1.32-4.52,7.92,1.17,7.8,2.7,13.28,5.61,22.52.77,2.41,2.48,6.69,5,8.76,3.16,2.56,7.92,2.45,15.12.66,3.07-.77,6.44-2.6,12.25-5.31C80.78,359,82,358.5,85,357.1a20.43,20.43,0,0,0,7.68-6c1.57-2.27,1.29-3.72,1-4.23s-.63-.13-1.47.82a16.58,16.58,0,0,1-4.41,4.08s1.94-2,3-3.3a16.72,16.72,0,0,0,2.32-3.78c.55-1.33-.59-3.13-1.46-2.18s-1.28,1.9-2.86,3.8A16.8,16.8,0,0,1,85.91,349a30.65,30.65,0,0,0,2.61-4.21c1-2.05-2.35-1-4.27,1-1.4,1.45-2.59,2.29-2.63,1.89s-2.76,2.53-4.15,4S70.39,355.37,64.56,356.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-17",
    d: "M43.45,324.11c4.09-.61,7,1.23,8.79,7.43s3.07,11.29,3.07,11.29a11.12,11.12,0,0,1-6.85,4.55c-4.9,1.18-6.66-1.15-6.66-1.15s-1.36-6.5-2.2-10.92S38.39,324.85,43.45,324.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M46,295.4s6.46-9.83-7.54-11.83c-10.1-1.44-16.59,5.05-17.34,12.09-.72,6.73,3.42,13.71,6.42,16.49,1.46.52,4.6.82,8.73-1.06a50,50,0,0,0,.19-5.51S31.54,295.22,46,295.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M78.82,349.11s-1.59-2.89-.58-3.61,2.45,2,2.74,3.05-.11-.32-.11-.32-1.09-3.27-.38-3.9,1.66.77,2.61,2.82.23-.17.23-.17-1.57-3.28-.9-3.74c.9-.6,2.38,1.34,3.26,3.09s-1.18,3.83-1.18,3.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mobile"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.89,354.28,76,350.85c-.51-.29-.44-.79.14-1.13l14.34-8.28a2.19,2.19,0,0,1,2-.08l5.94,3.43c.5.29.44.8-.14,1.13L83.85,354.2A2.16,2.16,0,0,1,81.89,354.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "75.61 350.36 75.61 349.81 76.25 350.05 75.61 350.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "98.67 345.26 98.67 344.74 98.16 345.06 98.67 345.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.89,353.82,76,350.39c-.51-.29-.44-.8.14-1.13L90.43,341a2.16,2.16,0,0,1,2-.08l5.94,3.43c.5.29.44.79-.14,1.13l-14.34,8.28A2.19,2.19,0,0,1,81.89,353.82Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 76.61,
    cy: 351,
    rx: 0.06,
    ry: 0.11,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -165.24, 85.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 76.9,
    cy: 351.16,
    rx: 0.06,
    ry: 0.11,
    transform: "translate(-165.29 85.5) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 77.18,
    cy: 351.33,
    rx: 0.06,
    ry: 0.11,
    transform: "translate(-165.33 85.67) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 77.47,
    cy: 351.49,
    rx: 0.06,
    ry: 0.11,
    transform: "translate(-165.37 85.83) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 79.92,
    cy: 352.91,
    rx: 0.06,
    ry: 0.11,
    transform: "translate(-165.75 87.25) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 80.21,
    cy: 353.08,
    rx: 0.06,
    ry: 0.11,
    transform: "translate(-165.8 87.41) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 80.49,
    cy: 353.24,
    rx: 0.06,
    ry: 0.11,
    transform: "translate(-165.84 87.58) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 80.78,
    cy: 353.41,
    rx: 0.06,
    ry: 0.11,
    transform: "translate(-165.89 87.74) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M79.09,352.55l-.79-.45a.23.23,0,0,1-.09-.18h0c0-.06,0-.09.09-.06l.79.45a.21.21,0,0,1,.09.17h0C79.18,352.55,79.14,352.58,79.09,352.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M96.87,346.56l-.73.42s-.08,0-.08-.06h0a.23.23,0,0,1,.08-.16l.73-.42s.09,0,.09.06h0A.19.19,0,0,1,96.87,346.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M95.75,347.21l-.73.42s-.08,0-.08-.06h0a.19.19,0,0,1,.08-.16l.73-.42s.09,0,.09.06h0A.2.2,0,0,1,95.75,347.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.89,353.74,76,350.31c-.51-.29-.44-.8.14-1.14l14.34-8.28a2.19,2.19,0,0,1,2-.08l5.94,3.43c.5.29.44.8-.14,1.13l-14.34,8.28A2.17,2.17,0,0,1,81.89,353.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97.69,344.38,95.38,343h0a1.08,1.08,0,0,1-1,0c-.28-.16-.28-.41,0-.57h0l-2.31-1.34a1.44,1.44,0,0,0-1.28,0l-14,8.06c-.35.21-.35.54,0,.74l5.63,3.25a1.42,1.42,0,0,0,1.27,0l14-8.07C98.05,344.91,98.05,344.58,97.69,344.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M97.69,344.38,95.38,343h0a1.08,1.08,0,0,1-1,0c-.28-.16-.28-.41,0-.57h0l-2.31-1.34a1.44,1.44,0,0,0-1.28,0l-14,8.06c-.35.21-.35.54,0,.74l5.63,3.25a1.42,1.42,0,0,0,1.27,0l14-8.07C98.05,344.91,98.05,344.58,97.69,344.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 94.72,
    cy: 342.84,
    rx: 0.27,
    ry: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.64,342.89s0-.07,0-.09a.15.15,0,0,1,.16,0s0,.06,0,.09A.22.22,0,0,1,94.64,342.89Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M91.12,352.91s3.14-2.83,3-6.58c-.19-2.61-1.77-.73-1.77-.73l-1.59,2.88a8.44,8.44,0,0,1-3,2.52,33.09,33.09,0,0,0-3.32.49c-1.95.38-3.89,2.82-3.89,2.82L83,356.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M76.55,220.38,18.74,187a4.49,4.49,0,0,0-3.85-.6h0a3,3,0,0,0-.69.4l-6.45,3.69,5,5.87v24.1a13.29,13.29,0,0,0,6,10.41l18,11.31,4.89,11.21-5.15,8.73,7.17-4.1,6.81-7.91L72.2,261.88l1.17,7,7.32-4.18.2-.12.07,0h0a4.35,4.35,0,0,0,1.6-3.79v-30A13.29,13.29,0,0,0,76.55,220.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M69.39,224.48,11.58,191.11c-3.32-1.92-6-.37-6,3.46v30a13.29,13.29,0,0,0,6,10.41l18,11.32,6.91,15.83,6.81-7.91,26.08,14.14c3.32,1.91,6,.36,6-3.47v-30A13.29,13.29,0,0,0,69.39,224.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M404.05,34.26,346.12.82a4.49,4.49,0,0,0-3.86-.61h0a2.65,2.65,0,0,0-.69.4l-6.46,3.7,5,5.87V34.34a13.32,13.32,0,0,0,6,10.43l18.05,11.34,4.9,11.23-5.15,8.75L371.1,72l6.82-7.93,21.76,11.8,1.18,7,7.33-4.2.2-.11.07,0h0a4.33,4.33,0,0,0,1.61-3.79v-30A13.32,13.32,0,0,0,404.05,34.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M404.05,34.26,346.12.82a4.49,4.49,0,0,0-3.86-.61h0a2.65,2.65,0,0,0-.69.4l-6.46,3.7,5,5.87V34.34a13.32,13.32,0,0,0,6,10.43l18.05,11.34,4.9,11.23-5.15,8.75L371.1,72l6.82-7.93,21.76,11.8,1.18,7,7.33-4.2.2-.11.07,0h0a4.33,4.33,0,0,0,1.61-3.79v-30A13.32,13.32,0,0,0,404.05,34.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M396.86,38.37,338.94,4.93c-3.32-1.92-6-.36-6,3.48v30a13.32,13.32,0,0,0,6,10.43L357,60.22l6.93,15.87,6.82-7.93,26.12,14.16c3.33,1.92,6,.37,6-3.47v-30A13.31,13.31,0,0,0,396.86,38.37Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 349.06,
    cy: 31.93,
    rx: 3.39,
    ry: 5.87,
    transform: "translate(30.8 178.81) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 366.23,
    cy: 41.85,
    rx: 3.39,
    ry: 5.87,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, 28.14, 188.73)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 383.41,
    cy: 51.77,
    rx: 3.39,
    ry: 5.87,
    transform: "translate(25.49 198.65) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M304.48,96.86c0-7-4.93-15.57-11-19.08-3.24-1.87-6.14-1.92-8.15-.52l-3.66,2.07,1.56.62a10.66,10.66,0,0,0-.77,4.19c0,7,4.93,15.56,11,19.08a11.58,11.58,0,0,0,3,1.25v2.19l4.72-2.66,0,0h0C303.26,102.81,304.48,100.35,304.48,96.86Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 289.42,
    cy: 92.84,
    rx: 8.99,
    ry: 15.58,
    transform: "translate(-7.64 157.15) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 285.08,
    cy: 87.46,
    rx: 1.28,
    ry: 2.22,
    transform: "translate(-5.54 154.27) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 293.62,
    cy: 92.39,
    rx: 1.28,
    ry: 2.22,
    transform: "translate(-6.86 159.19) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M285.08,94.26s1.44,3.94,4.34,5.61,4.6-.45,4.6-.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "99.92 306.32 106.14 309.92 106.14 293.89 99.92 290.3 99.92 306.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "106.14 293.91 99.92 290.31 104.96 287.4 111.43 291.02 106.14 293.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M129.76,305.34a4.53,4.53,0,0,0-2.2-3.73l-7.29-4.21,1.16-5.47v-.41a6,6,0,0,0-.24-1.72c-.22-.72-1-2.43-1.5-2.08l-7.63,4.41c-.46.13-.69.66-.69,1.46V307a5.15,5.15,0,0,0,2.31,4l10.41,6c.92.53,1.73.33,2.08-.4l3.47-7.48a2,2,0,0,0,.12-.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "122.1 319.2 125.77 317.05 122.43 312.52 122.1 319.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M126.26,307.38a4.56,4.56,0,0,0-2.2-3.73l-7.29-4.2,1.16-5.48v-.4a6.07,6.07,0,0,0-.24-1.73c-.22-.72-1-2.42-1.5-2.08l-7.63,4.41c-.46.13-.69.67-.69,1.47V309a5.13,5.13,0,0,0,2.31,4l10.41,6c.92.54,1.73.34,2.08-.4l3.47-7.48a2,2,0,0,0,.12-.87Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.d2fe75e7bb1cd8565599c8c68186bcfc.svg";
export { ForwardRef as ReactComponent };